import { render } from "./SectionHero.vue?vue&type=template&id=2e6698d6"
import script from "./SectionHero.vue?vue&type=script&lang=js"
export * from "./SectionHero.vue?vue&type=script&lang=js"

import "./SectionHero.vue?vue&type=style&index=0&id=2e6698d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__